import { API_BASE_URL } from '../config/api';

// Get user's IP and location
const getUserInfo = async () => {
  try {
    // Try to get location from browser
    let location = null;
    if (navigator.geolocation) {
      // Note: This requires user permission
      // For now, we'll use IP-based location
    }

    // Get IP address (will be captured by backend)
    return {
      location,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };
  } catch (error) {
    console.error('Error getting user info:', error);
    return {
      location: null,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };
  }
};

// Track page visit
export const trackPageVisit = async (page) => {
  try {
    const userInfo = await getUserInfo();
    const url = `${API_BASE_URL}/tracking/track`;
    
    console.log('🔵 Tracking page visit:', page, 'URL:', url, 'API_BASE_URL:', API_BASE_URL);
    
    const payload = {
      page,
      action: 'visit',
      ...userInfo,
    };
    
    console.log('🔵 Payload:', payload);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Tracking failed:', response.status, response.statusText, errorText);
      return;
    }

    const data = await response.json();
    console.log('✅ Page visit tracked successfully:', page, data);
  } catch (error) {
    console.error('❌ Tracking error:', error.message, error);
    // Don't fail silently - log the error
  }
};

// Track button click or action
export const trackAction = async (page, action, details = {}) => {
  try {
    const userInfo = await getUserInfo();
    const url = `${API_BASE_URL}/tracking/track`;
    
    console.log('🔵 [TRACKING] Starting action tracking:', action, 'Page:', page);
    console.log('🔵 [TRACKING] URL:', url);
    console.log('🔵 [TRACKING] API_BASE_URL:', API_BASE_URL);
    
    const payload = {
      page,
      action: `click_${action}`,
      ...userInfo,
      details: details && Object.keys(details).length > 0 ? JSON.stringify(details) : null,
    };
    
    console.log('🔵 [TRACKING] Payload:', JSON.stringify(payload, null, 2));
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    console.log('🔵 [TRACKING] Response status:', response.status, response.statusText);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ [TRACKING] Action tracking failed:', response.status, response.statusText, errorText);
      return;
    }

    const data = await response.json();
    console.log('✅ [TRACKING] Action tracked successfully!', action, page, data);
    return data;
  } catch (error) {
    console.error('❌ [TRACKING] Error:', error.message);
    console.error('❌ [TRACKING] Full error:', error);
    // Don't fail silently - log the error
    throw error;
  }
};
